const getCountText = (wrapper, count) => {
  const template = count === 1 ? wrapper.dataset.countSingular : wrapper.dataset.countPlural;
  return (template || '{0} bookings').replace('{0}', count);
};

const getBookingCards = (panel) => Array.from(panel.querySelectorAll('[data-user-booking-card]'));

const getBookingSearchValue = (card) => [
  card.dataset.userBookingSearchName || '',
  card.dataset.userBookingSearchHost || '',
  card.dataset.userBookingSearchReference || '',
].join(' ');

const getMatchingCardsCount = (panel, searchValue) => getBookingCards(panel).filter((card) => {
  return getBookingSearchValue(card).includes(searchValue);
}).length;

const updateActiveCount = (wrapper) => {
  const tabs = Array.from(wrapper.querySelectorAll('[data-user-bookings-tab]'));
  const activeTab = tabs.find((tab) => tab.classList.contains('active'));
  const activePanel = activeTab ? wrapper.querySelector(`[data-user-bookings-panel="${activeTab.dataset.userBookingsTab}"]`) : null;
  const activeCount = activePanel ? getBookingCards(activePanel).filter((card) => !card.classList.contains('hidden')).length : 0;
  const activeCountElement = wrapper.querySelector('[data-user-bookings-active-count]');
  const noResultsElement = wrapper.querySelector('[data-user-bookings-no-results]');

  if (activeCountElement) {
    activeCountElement.textContent = getCountText(wrapper, activeCount);
    activeCountElement.classList.toggle('hidden', activeCount === 0);
  }

  if (noResultsElement) {
    noResultsElement.classList.toggle('hidden', activeCount > 0);
  }
};

const filterBookings = (wrapper) => {
  const searchInput = wrapper.querySelector('[data-user-bookings-search]');
  const searchValue = searchInput ? searchInput.value.trim().toLowerCase() : '';
  const panels = Array.from(wrapper.querySelectorAll('[data-user-bookings-panel]'));

  panels.forEach((panel) => {
    getBookingCards(panel).forEach((card) => {
      card.classList.toggle('hidden', !getBookingSearchValue(card).includes(searchValue));
    });
  });

  Array.from(wrapper.querySelectorAll('[data-user-bookings-tab]')).forEach((tab) => {
    const countElement = wrapper.querySelector(`[data-user-bookings-tab-count="${tab.dataset.userBookingsTab}"]`);
    const panel = wrapper.querySelector(`[data-user-bookings-panel="${tab.dataset.userBookingsTab}"]`);

    if (countElement && panel) {
      countElement.textContent = getMatchingCardsCount(panel, searchValue);
    }
  });

  updateActiveCount(wrapper);
};

const initUserBookings = () => {
  Array.from(document.querySelectorAll('[data-user-bookings]:not([data-user-bookings-bound])')).forEach((wrapper) => {
    const searchInput = wrapper.querySelector('[data-user-bookings-search]');

    if (searchInput) {
      searchInput.addEventListener('input', () => filterBookings(wrapper));
    }

    Array.from(wrapper.querySelectorAll('[data-user-bookings-tab]')).forEach((tab) => {
      tab.addEventListener('click', () => window.requestAnimationFrame(() => updateActiveCount(wrapper)));
    });

    filterBookings(wrapper);
    wrapper.setAttribute('data-user-bookings-bound', 'true');
  });
};

export { initUserBookings };
